/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParentEnrollmentReviewConflict
 */
export interface ParentEnrollmentReviewConflict {
    /**
     * 
     * @type {string}
     * @memberof ParentEnrollmentReviewConflict
     */
    reviewedByEmail: string;
    /**
     * 
     * @type {Date}
     * @memberof ParentEnrollmentReviewConflict
     */
    reviewedAt: Date;
}

/**
 * Check if a given object implements the ParentEnrollmentReviewConflict interface.
 */
export function instanceOfParentEnrollmentReviewConflict(value: object): value is ParentEnrollmentReviewConflict {
    if (!('reviewedByEmail' in value) || value['reviewedByEmail'] === undefined) return false;
    if (!('reviewedAt' in value) || value['reviewedAt'] === undefined) return false;
    return true;
}

export function ParentEnrollmentReviewConflictFromJSON(json: any): ParentEnrollmentReviewConflict {
    return ParentEnrollmentReviewConflictFromJSONTyped(json, false);
}

export function ParentEnrollmentReviewConflictFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentEnrollmentReviewConflict {
    if (json == null) {
        return json;
    }
    return {
        
        'reviewedByEmail': json['reviewedByEmail'],
        'reviewedAt': (new Date(json['reviewedAt'])),
    };
}

export function ParentEnrollmentReviewConflictToJSON(json: any): ParentEnrollmentReviewConflict {
    return ParentEnrollmentReviewConflictToJSONTyped(json, false);
}

export function ParentEnrollmentReviewConflictToJSONTyped(value?: ParentEnrollmentReviewConflict | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reviewedByEmail': value['reviewedByEmail'],
        'reviewedAt': value['reviewedAt'].toISOString(),
    };
}

